import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from 'emotion';
import { TextArea as SourceTextArea } from '@guardian/src-text-area';
import { space } from '@guardian/src-foundations';
const textAreaStyles = css `
	width: 100%;
	margin-top: ${space[2]}px;
`;
export const TextArea = ({ formField, formData, setFormData }) => (_jsx(_Fragment, { children: _jsx(SourceTextArea, { "data-testid": `form-field-${formField.id}`, label: formField.label, className: textAreaStyles, optional: !formField.required, value: formField.id in formData ? formData[formField.id] : '', onChange: (e) => setFormData({
            ...formData,
            [formField.id]: e.target.value,
        }) }, void 0) }, void 0));
